exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@keyframes speaker-box{0%{height:0;opacity:0;overflow:hidden}to{height:48px;opacity:1;overflow:hidden}}.speaker{background:#55614e;color:#fff;border-radius:10px 100px 0 0;width:200px;float:left;margin-bottom:-4px;height:48px;padding:4px;line-height:56px;font-family:Fjalla One,sans-serif;font-size:36px;animation-name:speaker-box;animation-iteration-count:1;animation-duration:.7s;animation-timing-function:cubic-bezier(0,0,.22,2.28)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/Speaker/styles.sass
// module id = 120
// module chunks = 0